var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveAutopilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.8V14.4L13.3158 8.4V1.8C13.3158 0.804 12.5047 0 11.5 0C10.4953 0 9.68421 0.804 9.68421 1.8V8.4L0 14.4V16.8L9.68421 13.8V20.4L7.26316 22.2V24L11.5 22.8L15.7368 24V22.2L13.3158 20.4V13.8L23 16.8Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAutopilot);
export default __webpack_public_path__ + "static/media/activeAutopilot.fa7fab4407725391e4f35b7c6e4c2373.svg";
export { ForwardRef as ReactComponent };